import LottoMachineController from './js/controller/LottoMachineController.js';
import './css/index.css';

new LottoMachineController();
